import React from 'react'

import TimeIcon from 'Assets/Images/icons/time'
import NoTimeIcon from 'Assets/Images/icons/noTime'
import DownloadIcon from 'Assets/Images/icons/download'
import {
  StyledDownloadSection,
  StyledDownloadLink,
  StyledReportTypeSpan,
} from './styles'

import {
  CONVERSION_REPORT_TYPE,
  CONVERSION_REPORT_TYPE_SHOW,
} from '../../../../../shared/constants'

const ShowReportType = ({ reportType, templateCSVFile }) => {
  const getReportTypeSection = () => {
    switch (reportType) {
      case CONVERSION_REPORT_TYPE.WITH_TIMESTAMP:
        return (
          <StyledReportTypeSpan>
            <TimeIcon />
            Report type:{' '}
            {CONVERSION_REPORT_TYPE_SHOW[CONVERSION_REPORT_TYPE.WITH_TIMESTAMP]}
          </StyledReportTypeSpan>
        )
      case CONVERSION_REPORT_TYPE.WITHOUT_TIMESTAMP:
        return (
          <StyledReportTypeSpan>
            <NoTimeIcon />
            Report type:{' '}
            {
              CONVERSION_REPORT_TYPE_SHOW[
                CONVERSION_REPORT_TYPE.WITHOUT_TIMESTAMP
              ]
            }
          </StyledReportTypeSpan>
        )
      default:
        return (
          <StyledReportTypeSpan>Report type: not selected</StyledReportTypeSpan>
        )
    }
  }

  return (
    <StyledDownloadSection>
      {getReportTypeSection()}
      {reportType !== CONVERSION_REPORT_TYPE.NO_TYPE && (
        <StyledDownloadLink {...templateCSVFile}>
          <DownloadIcon />
          Download template
        </StyledDownloadLink>
      )}
    </StyledDownloadSection>
  )
}

export default ShowReportType
